import React, { useContext } from "react";
import { ContextEmitedCreditNotes } from "..";
import DownloadXml from "./DownloadXml";
import style from "../styles.module.scss";
import DownloadPdf from "./DownloadPdf";
import CancelCreditNoteEmited from "structure/CancelCreditNoteEmited";
import LinkCreditNoteAssociatedFiles from "./AssociatedFiles";
import { ModalEmail } from "structure/EmailV2";
import ButtonV2 from "components/individual/ButtonsV2/Button";
import { downloadFeFiles } from "helpers/Apis/associateFilesV2";

const Container = ({ children }) => (
  <div className={style.containerOptionsCreditNote}>{children}</div>
);

export default function CreditNoteOptions() {
  const hook = useContext(ContextEmitedCreditNotes);

  if (hook.creditNote === undefined)
    return (
      <Container>
        <></>
      </Container>
    );

  return (
    <Container>
      <LinkCreditNoteAssociatedFiles />
      <ModalEmail
        idModule={hook.creditNote.id}
        files={() => downloadFeFiles(hook.creditNote.xml, hook.creditNote.pdf)}
        module="notaDeCredito"
        idDirectory={hook.creditNote.customer.id}
      >
        <ButtonV2>
          <span>Enviar correo</span>
        </ButtonV2>
      </ModalEmail>
      <DownloadXml />
      <DownloadPdf />
      <CancelCreditNoteEmited
        uuidCreditNote={hook.creditNote.uuid}
        isCancelled={
          hook.creditNote.status.id === 15 || hook.creditNote.status.id === null
        }
        onCancelated={() => hook.refetchTable()}
      />
    </Container>
  );
}
